(function () {
  const MOBILE_BREAKPOINT = 749;
  const FULLSCREEN_POINT = 0.5;

  /* =========================================================
     HELPERS
  ========================================================= */

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function lerp(start, end, progress) {
    return start + (end - start) * progress;
  }

  function easeInOutCubic(value) {
    if (value < 0.5) {
      return 4 * value * value * value;
    }

    return 1 - Math.pow(-2 * value + 2, 3) / 2;
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getViewportHeight() {
    if (
      window.visualViewport &&
      window.visualViewport.height
    ) {
      return window.visualViewport.height;
    }

    return window.innerHeight;
  }

  function readNumber(section, variable, fallback) {
    const raw = getComputedStyle(section)
      .getPropertyValue(variable)
      .trim();

    const number = parseFloat(raw);

    return Number.isFinite(number)
      ? number
      : fallback;
  }


  /* =========================================================
     SECTION INIT
  ========================================================= */

  function initSection(section) {
    if (!section) return;

    if (
      section.dataset.furScrollVideoReady === 'true'
    ) {
      return;
    }

    const area = section.querySelector(
      '[data-fur-scroll-video-area]'
    );

    const sticky = section.querySelector(
      '[data-fur-scroll-video-sticky]'
    );

    const frame = section.querySelector(
      '[data-fur-scroll-video-frame]'
    );

    const intro = section.querySelector(
      '[data-fur-scroll-video-intro]'
    );

    const mediaElements = Array.from(
      section.querySelectorAll(
        '[data-fur-video-media]'
      )
    );

    if (!area || !sticky || !frame) {
      return;
    }

    section.dataset.furScrollVideoReady = 'true';


    /* =====================================================
       STORE ORIGINAL BAG CLIP
    ===================================================== */

    mediaElements.forEach(function (media) {
      const clip =
        media.style.clipPath ||
        media.style.webkitClipPath;

      if (clip) {
        media.dataset.furOriginalClip = clip;
      }
    });


    /* =====================================================
       VIDEO AUTOPLAY
    ===================================================== */

    const videos = Array.from(
      section.querySelectorAll('video')
    );

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
    });


    function getVisibleVideo() {
      return section.querySelector(
        isMobile()
          ? '.fur-scroll-video__video--mobile'
          : '.fur-scroll-video__video--desktop'
      );
    }


    function playVisibleVideo() {
      const visible = getVisibleVideo();

      videos.forEach(function (video) {
        if (video === visible) {
          video.muted = true;

          const promise = video.play();

          if (
            promise &&
            typeof promise.catch === 'function'
          ) {
            promise.catch(function () {});
          }
        } else {
          try {
            video.pause();
          } catch (error) {}
        }
      });
    }


    /* =====================================================
       SCROLL PROGRESS
    ===================================================== */

    function getProgress() {
      const vh = getViewportHeight();

      const rect = area.getBoundingClientRect();

      const totalDistance = Math.max(
        1,
        area.offsetHeight - vh
      );

      return clamp(
        -rect.top / totalDistance,
        0,
        1
      );
    }


    /* =====================================================
       STARTING BAG DIMENSIONS
    ===================================================== */

    function getStartDimensions() {
      const mobile = isMobile();

      const vw = window.innerWidth;
      const vh = getViewportHeight();

      const widthPercent = readNumber(
        section,
        mobile
          ? '--fsv-mobile-start-width'
          : '--fsv-desktop-start-width',
        mobile ? 68 : 31
      );

      const heightPercent = readNumber(
        section,
        mobile
          ? '--fsv-mobile-start-height'
          : '--fsv-desktop-start-height',
        mobile ? 58 : 60
      );

      return {
        width: vw * (widthPercent / 100),
        height: vh * (heightPercent / 100)
      };
    }


    /* =====================================================
       BAG MASK
    ===================================================== */

    function showBagMask() {
      mediaElements.forEach(function (media) {
        const clip =
          media.dataset.furOriginalClip;

        if (clip) {
          media.style.clipPath = clip;
          media.style.webkitClipPath = clip;
        }
      });

      section.classList.remove(
        'is-fullscreen'
      );
    }


    function removeBagMask() {
      mediaElements.forEach(function (media) {
        media.style.clipPath = 'none';
        media.style.webkitClipPath = 'none';
      });

      section.classList.add(
        'is-fullscreen'
      );
    }


function apply(rawProgress) {

  const vw = window.innerWidth;
  const vh = getViewportHeight();

  const start = getStartDimensions();


  /* =====================================================
     0% → 50%
     SCALE BAG UNIFORMLY

     Width/height NEVER change independently.
     Therefore bag shape/proportions stay identical.
  ===================================================== */

  const expansionProgress = clamp(
    rawProgress / 0.5,
    0,
    1
  );

  const easedExpansion =
    easeInOutCubic(expansionProgress);


  /*
   * One single scale value.
   *
   * max() guarantees the bag eventually covers
   * the entire viewport without changing its ratio.
   */
  const fullscreenScale = Math.max(
    vw / start.width,
    vh / start.height
  );


  const scale = lerp(
    1,
    fullscreenScale,
    easedExpansion
  );


  /* =====================================================
     BEFORE 50%
     KEEP ORIGINAL BAG DIMENSIONS
  ===================================================== */

  if (rawProgress < 0.5) {

    frame.style.width =
      start.width + 'px';

    frame.style.height =
      start.height + 'px';

    frame.style.transform =
      'translate3d(0,0,0) scale(' +
      scale +
      ')';


    /* KEEP BAG MASK */

    mediaElements.forEach(function (media) {

      const clip =
        media.dataset.furOriginalClip;

      if (clip) {

        media.style.clipPath =
          clip;

        media.style.webkitClipPath =
          clip;

      }

    });


    section.classList.remove(
      'is-fullscreen'
    );

  }


  /* =====================================================
     50% → 100%
     SWITCH TO TRUE FULLSCREEN

     At this exact point:
     - bag has finished expanding
     - mask disappears
     - frame becomes 100vw × 100vh
  ===================================================== */

  else {

    frame.style.width =
      vw + 'px';

    frame.style.height =
      vh + 'px';

    frame.style.transform =
      'translate3d(0,0,0) scale(1)';


    mediaElements.forEach(function (media) {

      media.style.clipPath =
        'none';

      media.style.webkitClipPath =
        'none';

    });


    section.classList.add(
      'is-fullscreen'
    );

  }


  /* =====================================================
     INTRO
  ===================================================== */

  if (intro) {

    const introOpacity = clamp(
      1 - rawProgress / 0.32,
      0,
      1
    );


    intro.style.opacity =
      introOpacity;


    intro.style.transform =
      'translate3d(0,' +
      (rawProgress * -24) +
      'px,0)';


    intro.style.pointerEvents =
      introOpacity <= 0.01
        ? 'none'
        : '';

  }


  /* =====================================================
     PROGRESS STATES
  ===================================================== */

  section.style.setProperty(
    '--fsv-progress',
    rawProgress
  );


  section.classList.toggle(
    'is-expanding',
    rawProgress > 0 &&
    rawProgress < 0.5
  );


  section.classList.toggle(
    'is-locked',
    rawProgress >= 0.5 &&
    rawProgress < 1
  );

}
    /* =====================================================
       SMOOTH RAF
    ===================================================== */

    let current = getProgress();
    let target = current;
    let raf = null;


    function animate() {
      const difference =
        target - current;

      current +=
        difference * 0.16;

      if (
        Math.abs(difference) < 0.0005
      ) {
        current = target;
      }

      apply(current);

      if (
        Math.abs(target - current) >
        0.0005
      ) {
        raf = requestAnimationFrame(
          animate
        );
      } else {
        raf = null;
      }
    }


    function update() {
      target = getProgress();

      if (raf === null) {
        raf = requestAnimationFrame(
          animate
        );
      }
    }


    /* =====================================================
       RESIZE
    ===================================================== */

    function handleResize() {
      current = getProgress();
      target = current;

      apply(current);

      playVisibleVideo();
    }


    /* =====================================================
       EVENTS
    ===================================================== */

    window.addEventListener(
      'scroll',
      update,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      handleResize,
      {
        passive: true
      }
    );

    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        'resize',
        handleResize,
        {
          passive: true
        }
      );
    }


    videos.forEach(function (video) {
      video.addEventListener(
        'canplay',
        playVisibleVideo
      );
    });


    apply(current);
    playVisibleVideo();
  }


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initAll(root) {
    const context =
      root || document;

    if (
      context.matches &&
      context.matches(
        '[data-fur-scroll-video]'
      )
    ) {
      initSection(context);
    }

    if (context.querySelectorAll) {
      context
        .querySelectorAll(
          '[data-fur-scroll-video]'
        )
        .forEach(initSection);
    }
  }


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);
    }
  );

})();